(function () {

  /* ── Backdrop (bir kez oluştur) ─────────────── */
  if (!document.getElementById('cbadge-backdrop')) {
    var bd = document.createElement('div');
    bd.id = 'cbadge-backdrop';
    bd.className = 'cbadge-backdrop';
    document.body.appendChild(bd);
    bd.addEventListener('click', closeAll);
    bd.addEventListener('touchend', function (e) { e.preventDefault(); closeAll(); }, { passive: false });
  }

  function closeAll() {
    document.querySelectorAll('.cbadge-popup:not([hidden])').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('.cbadge[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (window.innerWidth <= 749) {
      var bd = document.getElementById('cbadge-backdrop');
      if (bd) bd.classList.remove('active');
    }
  }

  /* ── Popup'u sadece ilk etkileşimde oluştur ── */
  function buildPopup(btn) {
    var popupId = btn.getAttribute('aria-controls');
    var existing = document.getElementById(popupId);
    if (existing) return existing;

    var title    = btn.getAttribute('data-title') || 'Renk Seçenekleri';
    var products = [];
    try { products = JSON.parse((btn.getAttribute('data-products') || '[]').replace(/,\s*]/g, ']')); } catch (e) {}
    var popup = document.createElement('div');
    popup.className  = 'cbadge-popup';
    popup.id         = popupId;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-label', 'Renk seçenekleri');
    popup.setAttribute('aria-modal', 'true');
    popup.hidden = true;

    var items = products.map(function (p) {
      var media = p.img
        ? '<img src="' + p.img + '" alt="' + p.alt + '" width="150" height="200" loading="lazy">'
        : '<div class="cbadge-popup__no-img">' + p.initial + '</div>';
      return '<a href="' + p.url + '" class="cbadge-popup__item' + (p.active ? ' cbadge-popup__item--active' : '') + '">'
        + '<div class="cbadge-popup__img-wrap">' + media + '</div>'
        + '<span class="cbadge-popup__price">' + p.price + '</span>'
        + '</a>';
    }).join('');

    popup.innerHTML =
      '<div class="cbadge-popup__header">'
        + '<span class="cbadge-popup__title">' + title + '</span>'
        + '<button class="cbadge-popup__close" type="button" aria-label="Kapat">&#x2715;</button>'
      + '</div>'
      + '<div class="cbadge-popup__grid">' + items + '</div>';

    document.body.appendChild(popup);

    popup.querySelector('.cbadge-popup__close').addEventListener('click', function (e) {
      e.stopPropagation(); closeAll();
    });

    return popup;
  }

  /* ── Masaüstü konumlandırma ─────────────────── */
  function positionPopup(btn, popup) {
    if (window.innerWidth <= 749) return;

    var container = btn.closest('.card-gallery, .product-media-container, [class*="card"][class*="media"], [class*="card"][class*="image"]');
    if (!container) {
      var el = btn.parentElement;
      while (el && el !== document.body) {
        if (getComputedStyle(el).position !== 'static') { container = el; break; }
        el = el.parentElement;
      }
    }
    if (!container) container = btn.parentElement;

    var r = container.getBoundingClientRect();
    popup.style.cssText = [
      'left:'   + (r.left + window.scrollX) + 'px',
      'bottom:' + (window.innerHeight - r.bottom - window.scrollY) + 'px',
      'top:auto',
      'width:'  + r.width + 'px',
      'right:auto'
    ].join(';');
  }

  /* ── Hover (masaüstü) ───────────────────────── */
  function setupHover(btn) {
    if (window.innerWidth <= 749) return;
    if (btn._cbHoverReady) return;
    btn._cbHoverReady = true;

    var leaveTimer;

    function showPopup() {
      clearTimeout(leaveTimer);
      var popup = buildPopup(btn);
      document.querySelectorAll('.cbadge-popup:not([hidden])').forEach(function (p) {
        if (p !== popup) p.hidden = true;
      });
      popup.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      positionPopup(btn, popup);
    }

    function hidePopup() {
      leaveTimer = setTimeout(function () {
        var popup = document.getElementById(btn.getAttribute('aria-controls'));
        if (popup) popup.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }, 120);
    }

    btn.addEventListener('mouseenter', showPopup);
    btn.addEventListener('mouseleave', hidePopup);

    /* Popup üzerindeyken kapanmasın */
    btn.addEventListener('mouseenter', function () {
      var popup = document.getElementById(btn.getAttribute('aria-controls'));
      if (popup) {
        popup.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); }, { once: false });
        popup.addEventListener('mouseleave', hidePopup, { once: false });
      }
    });
  }

  /* ── Tıklama (mobil) ────────────────────────── */
  if (!document._cbadgeGlobalClick) {
    document._cbadgeGlobalClick = true;

    document.addEventListener('click', function (e) {
      if (window.innerWidth > 749) return;

      var closeBtn = e.target.closest('.cbadge-popup__close');
      if (closeBtn) { e.stopPropagation(); closeAll(); return; }

      var btn = e.target.closest('.cbadge');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var popup  = buildPopup(btn);
      var isOpen = !popup.hidden;
      closeAll();
      if (!isOpen) {
        popup.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var bd = document.getElementById('cbadge-backdrop');
        if (bd) bd.classList.add('active');
      }
    });
  }

  /* ── Başlat ─────────────────────────────────── */
  function init() {
    document.querySelectorAll('.cbadge').forEach(setupHover);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  /* ── Klavye ─────────────────────────────────── */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ── Scroll / resize ────────────────────────── */
  window.addEventListener('scroll', function () {
    var btn = document.querySelector('.cbadge[aria-expanded="true"]');
    if (!btn || window.innerWidth <= 749) return;
    var popup = document.getElementById(btn.getAttribute('aria-controls'));
    if (popup && !popup.hidden) positionPopup(btn, popup);
  }, { passive: true });

  window.addEventListener('resize', function () {
    closeAll();
    document.querySelectorAll('.cbadge').forEach(function (btn) {
      btn._cbHoverReady = false;
      setupHover(btn);
    });
  }, { passive: true });

})();